import type GeoJSON from 'geojson';

// Build a triangular direction-arrow polygon.
// When baseInward=true (apex pinned to the wellbore): tip sits at (lat, lon) and
// the base extends outward in the +(dirDx, dirDy) direction.
// Otherwise (apex outward): base sits at (lat, lon) and the tip extends out in
// the +(dirDx, dirDy) direction.
export const buildArrowPolygon = (
  lat: number,
  lon: number,
  dirDx: number,
  dirDy: number,
  perpDx: number,
  perpDy: number,
  arrowLen: number,
  halfWidth: number,
  baseInward: boolean
): GeoJSON.FeatureCollection => {
  const latDegPerFt = 1 / (69 * 5280);
  const lonDegPerFt = 1 / (69 * Math.cos((lat * Math.PI) / 180) * 5280);

  const tipLat = baseInward ? lat : lat + dirDy * arrowLen * latDegPerFt;
  const tipLon = baseInward ? lon : lon + dirDx * arrowLen * lonDegPerFt;
  const baseCenterLat = baseInward ? lat + dirDy * arrowLen * latDegPerFt : lat;
  const baseCenterLon = baseInward ? lon + dirDx * arrowLen * lonDegPerFt : lon;
  const baseRLat = baseCenterLat + perpDy * halfWidth * latDegPerFt;
  const baseRLon = baseCenterLon + perpDx * halfWidth * lonDegPerFt;
  const baseLLat = baseCenterLat - perpDy * halfWidth * latDegPerFt;
  const baseLLon = baseCenterLon - perpDx * halfWidth * lonDegPerFt;

  return {
    type: 'FeatureCollection' as const,
    features: [
      {
        type: 'Feature' as const,
        geometry: {
          type: 'Polygon' as const,
          coordinates: [
            [
              [tipLon, tipLat],
              [baseRLon, baseRLat],
              [baseLLon, baseLLat],
              [tipLon, tipLat],
            ],
          ],
        },
        properties: {},
      },
    ],
  };
};
